import { BusStopMarker } from "@/types";
import { computed } from "vue";

export const useBusStopCluster = () => {
  const primary = computed(() =>
    getComputedStyle(document.documentElement).getPropertyValue("--primary")
  );
  const primaryAlpha20 = computed(() =>
    getComputedStyle(document.documentElement).getPropertyValue(
      "--primary-alpha20"
    )
  );

  const htmlClusterMarker = {
    content: `<div class="cluster" style="cursor:pointer; width:34px; height:34px; line-height:34px; font-size:14px; color:white; text-align:center; font-weight:bold; background-color:${primary.value}; background-size:contain; box-shadow: 0px 0px 0px 10px ${primaryAlpha20.value}; border-radius:50%"></div>`,
  };

  const setClusterStyle = (cluster: any) => {
    const clusterEventTarget = cluster._clusterMarker?.eventTarget;
    if (clusterEventTarget) {
      const clusterMember = cluster.getClusterMember();
      clusterEventTarget.textContent = clusterMember.length;
    }
  };

  const createBusStopCluster = (map: any, busStopMakers: BusStopMarker[]) => {
    if (!busStopMakers.length) return;

    const markers = busStopMakers.map((busStopMaker) => busStopMaker.marker);
    // eslint-disable-next-line no-undef
    new window.MarkerClustering({
      minClusterSize: 2,
      maxZoom: 20,
      map: map,
      markers: markers,
      disableClickZoom: false,
      gridSize: 120,
      icons: [htmlClusterMarker],
      stylingFunction: setClusterStyle,
    });
  };

  return { createBusStopCluster };
};
